export default __webpack_public_path__ + "static/media/timeline-full.8f4c3845.svg";